/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{isVariantLabel as i}from"../../render/utils/is-variant-label.js";import{isControllingVariants as r}from"../../render/utils/is-controlling-variants.js";function t(t,n){if(r(t)){const{initial:r,animate:n}=t;return{initial:!1===r||i(r)?r:void 0,animate:i(n)?n:void 0}}return!1!==t.inherit?n:{}}export{t as getCurrentTreeVariants};
//# sourceMappingURL=utils.js.map
